import ReactMarkdown from 'react-markdown';
import { ChatMessage as Msg } from './types';

export function ChatMessage({ message }: { message: Msg }) {
  const isUser = message.role === 'user';

  return (
    <div className={`flex ${isUser ? 'justify-end' : 'justify-start'} mb-2.5`}>
      <div
        className={`max-w-[85%] px-3.5 py-2.5 rounded-2xl text-sm ${
          isUser
            ? 'bg-slate-700 text-white rounded-br-sm leading-relaxed whitespace-pre-wrap'
            : 'bg-gray-100 text-gray-900 rounded-bl-sm leading-snug'
        }`}
      >
        {isUser ? (
          message.content
        ) : (
          <ReactMarkdown
            components={{
              p: ({ children }) => <p className="mb-1.5 last:mb-0">{children}</p>,
              strong: ({ children }) => <strong className="font-semibold text-gray-950">{children}</strong>,
              ul: ({ children }) => <ul className="mb-1.5 ml-4 list-disc space-y-0.5 last:mb-0">{children}</ul>,
              ol: ({ children }) => <ol className="mb-1.5 ml-4 list-decimal space-y-0.5 last:mb-0">{children}</ol>,
              li: ({ children }) => <li className="pl-0.5">{children}</li>,
            }}
          >
            {message.content}
          </ReactMarkdown>
        )}
      </div>
    </div>
  );
}
